import { Box, Text, TextProps } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { ActivityIndicator } from 'react-native'
import { aepsTheme } from '../../util/customTheme'

export const ResendOtp = ({ onResendOTPPress, showLoader = false }: any) => {
  const [resendCount, setResendCount] = useState(0)
  const [countDowntimer, setCountDownTimer] = useState(30)

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [countDowntimer])

  const onResendOtp = () => {
    setCountDownTimer(30)
    setResendCount(resendCount + 1)
    onResendOTPPress()
  }
  const ShowCountingText = () => {
    return (
      <Text {...styles.countStyle}>
        {countDowntimer > 0 && resendCount < 3 ? `Resend OTP  ( ${countDowntimer} )` : 'Resend limit exceeded'}
      </Text>
    )
  }
  const ShowResend = () => (
    <>
      {resendCount < 3 ? (
        <Box underlayColor="VERY_LIGHT_GREY" onPress={onResendOtp} alignItems={'center'}>
          <Text {...styles.resendText}>{'Resend OTP'}</Text>
        </Box>
      ) : (
        <Text {...styles.countStyle}>Resend limit exceeded </Text>
      )}
    </>
  )
  if (showLoader) {
    return <ActivityIndicator size={'small'} color={aepsTheme.colors.PRIMARY} />
  }

  return <>{countDowntimer > 0 ? ShowCountingText() : ShowResend()}</>
}

const styles = {
  resendText: {
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: 'PRIMARY_STORNG',
  } as TextProps,
  countStyle: {
    fontSize: 12,
    fontFamily: 'jioType-medium',
    color: 'DISABLED_GREY',
  } as TextProps,
}
